module.exports = __webpack_public_path__ + "static/media/VRED Presenter.65e5cd6f.png";